import { render } from "./Historic.vue?vue&type=template&id=3df426be&scoped=true"
import script from "./Historic.vue?vue&type=script&lang=js"
export * from "./Historic.vue?vue&type=script&lang=js"

import "./Historic.vue?vue&type=style&index=0&id=3df426be&scoped=true&lang=css"

import exportComponent from "C:\\projects\\dcc\\site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3df426be"]])

export default __exports__